(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/analytics/assets/javascripts/misc-events.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/analytics/assets/javascripts/misc-events.js');
"use strict";


const trackSandwichFilterClicked = eventData => {
  const interaction = eventData.kambi.interaction;
  const isLevelOneClick = interaction.label.includes('L1');
  if (!isLevelOneClick) {
    return;
  }
  svs.components.analytics.trackEvent({
    category: 'navigation oddset',
    action: 'sandwich filter',
    opt_label: interaction.filterLevel1
  });
};
const highlightType = 'oh';
const trackHighlightPromoView = eventData => {
  var _eventData$kambi$inte;
  const data = {
    id: location.pathname,
    name: "".concat(highlightType, "/").concat(eventData.kambi.interaction.creative_slot, "/").concat((_eventData$kambi$inte = eventData.kambi.interaction.promotion_item_name) !== null && _eventData$kambi$inte !== void 0 ? _eventData$kambi$inte : 'unknown'),
    position: ''
  };
  svs.components.analytics.trackPromoImpression(data);
};
const trackHighlightPromoClick = eventData => {
  const data = {
    id: '/odds',
    name: "".concat(highlightType, "/").concat(eventData.kambi.interaction.creative_slot).concat(eventData.kambi.page.path),
    position: ''
  };
  svs.components.analytics.trackPromoClick(data);
};
const trackLiveStreamInteraction = eventData => {
  var _eventData$kambi;
  if (((_eventData$kambi = eventData.kambi) === null || _eventData$kambi === void 0 || (_eventData$kambi = _eventData$kambi.interaction) === null || _eventData$kambi === void 0 ? void 0 : _eventData$kambi.action) === 'LOAD') {
    svs.components.analytics.trackEvent({
      category: 'streamplayer interaction',
      action: eventData.kambi.interaction.action,
      opt_label: eventData.kambi.page.title
    });
  }
};
const SEARCH_THROTTLE_DELAY = 5000;
const throttle = (mainFunction, delay) => {
  let timerFlag = null;
  return function () {
    if (timerFlag === null) {
      mainFunction(...arguments);
      timerFlag = setTimeout(() => {
        timerFlag = null;
      }, delay);
    }
  };
};
const trackSearchResult = searchTerm => {
  svs.components.analytics.trackSearch(searchTerm, 'Oddset');
};
setGlobal('svs.oddset_kambi.components.analytics.miscEvents', {
  trackSandwichFilterClicked,
  trackHighlightPromoClick,
  trackLiveStreamInteraction,
  trackHighlightPromoView,
  trackSearchResult: throttle(trackSearchResult, SEARCH_THROTTLE_DELAY)
});

 })(window);